import type { SxProps, Theme } from '@mui/material/styles';

export const styles = {
    button: {
        color: 'text.secondary',
        textTransform: 'none',
    },
} satisfies Record<string, SxProps<Theme>>;
